function debounceFn(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer), (timer = setTimeout(() => fn(...args), delay));
  };
}

class EventTracker {
  constructor(config) {
    this.modules = {
      // screen: new ScreenModule(config?.screen),
      scroll: new ScrollModule(config?.scroll),
    };
  }
  init() {
    Object.values(this.modules).forEach(m => m.init());
  }
}
class ScreenModule {
  constructor(config) {
    (this.config = {
      mode: 'viewport',
      selector: null,
      minStay: 800,
      ga4Name: 'viewport',
    }),
      (this.currentScreen = null),
      (this.enterTime = 0),
      (this.data = new Map()),
      (this.innerHeight = innerHeight),
      (this.screenList = this.getScreens());
  }
  init() {
    this.enterTime = Date.now();
    this.bindScroll(), this.bindUnload();
  }
  bindScroll = () => {
    window.addEventListener('scroll', this.handleScroll);
  };
  handleScroll = debounceFn(() => {
    const scrollY2 = window.scrollY || pageYOffset,
      newScreen = this.detectScreen(scrollY2);
    newScreen?.id !== this.currentScreen && this.recordStay(newScreen?.id);
  }, 150);
  detectScreen(scrollY2) {
    return this.screenList.find(s => scrollY2 >= s.top && scrollY2 < s.bottom);
  }
  getScreens() {
    if (this.config.mode === 'viewport') {
      const h = innerHeight;
      return Array.from(
        {
          length: Math.ceil(document.documentElement.scrollHeight / h),
        },
        (_, i) => ({
          id: `${i}`,
          top: i * h,
          bottom: (i + 1) * h,
        }),
      );
    } else if (this.config.mode === 'selector')
      return [...document.querySelectorAll(this.config.selector)].map((el, i) => {
        const rect = el.getBoundingClientRect();
        return {
          id: el.id || `${i}`,
          top: rect.top + scrollY,
          bottom: rect.bottom + scrollY,
        };
      });
    return [];
  }
  recordStay(newScreenId) {
    const now = Date.now();
    if (this.currentScreen && this.enterTime > 0) {
      const duration = now - this.enterTime;
      if (duration >= this.config.minStay) {
        const entry = this.data.get(this.currentScreen) || {
          stay: 0,
          count: 0,
        };
        (entry.stay += duration), entry.count++, this.data.set(this.currentScreen, entry);
      }
    }
    (this.currentScreen = newScreenId), (this.enterTime = now);
  }
  report() {
    if (this.data.size === 0) return;
    const params = {
      content_type: this.config.ga4Name,
      section_id: this.config.ga4Name,
      section_name: this.config.ga4Name,
      extra_data: JSON.stringify(
        [...this.data].map(([id, data]) => [id, (data.stay / 1000).toFixed(), data.count]),
      ),
      viewporpWidth: innerWidth,
      viewporpHeight: innerHeight,
    };
    // GAReporter.report(params);
    setTimeout(function () {window.gtag && gtag('event', 'click_manual', params)})
    this.data.clear();
  }
  bindUnload() {
    window.addEventListener('beforeunload', () => this.report()),
      document.addEventListener('visibilitychange', () => {
        document.visibilityState === 'hidden' && this.report();
      });
  }
}
class ScrollModule {
  constructor(config) {
    (this.config = {
      ga4Name: 'scroll',
      ...config,
    }),
      (this.data = {
        scrollCount: 0,
        maxScrollHeight: 0,
        lastScrollHeight: 0,
        viewTime: 0,
      }),
      (this.enterTime = 0);
  }
  init() {
    this.enterTime = Date.now();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('beforeunload', this.report);
  }
  handleScroll = debounceFn(() => {
    const scrollY2 = window.scrollY || window.pageYOffset;
    scrollY2 !== this.data.lastScrollHeight &&
      ((this.data.scrollCount += 1),
        (this.data.lastScrollHeight = scrollY2),
        (this.data.maxScrollHeight = Math.max(this.data.maxScrollHeight, scrollY2)));
  }, 200);
  report = () => {
    const params = {
      content_type: this.config.ga4Name,
      section_id: this.config.ga4Name,
      section_name: this.config.ga4Name,
      scrollCount: this.data.scrollCount,
      maxScrollHeight: this.data.maxScrollHeight,
      lastScrollHeight: this.data.lastScrollHeight,
      viewTime: ((Date.now() - this.enterTime) / 1000).toFixed(),
    };
    // GAReporter.report(params);
    setTimeout(function () {window.gtag && gtag('event', 'click_manual', params)})
  };
}

$(document).ready(() => {
  const tracker = new EventTracker({
    // screen: {
    //   mode: 'viewport',
    //   ga4Name: 'viewport',
    // },
    scroll: {
      ga4Name: 'scroll',
    },
  });
  tracker.init();
});
